import EntityDetailButton from '@/components/entity-detail/components/Button';
import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import type { TableColumnConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';

export const columns = (columnParams: any): TableColumnConfig[] => [
    {
        field: 'code',
        headerName: 'Mã Task',
        editable: false,
        sortable: true,
        minWidth: 70,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
    {
        field: 'name',
        headerName: 'Tên Task',
        editable: false,
        sortable: false,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.value} />,
    },
    {
        field: 'taskCheckTypeName',
        headerName: 'Loại',
        editable: false,
        sortable: false,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row?.taskCheckType?.name} />
        ),
    },
    {
        field: 'user',
        headerName: 'Người thực hiện',
        editable: false,
        sortable: false,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row?.assignee?.fullname}>
                <EntityDetailButton
                    text={params.row?.assignee?.fullname}
                    identifier={columnParams?.identifier}
                    entityId={params.row?.assignee?.id}
                    type='ASSIGNEE'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.KTV],
    },
    {
        field: 'startAt',
        headerName: 'Ngày bắt đầu chu kì',
        editable: false,
        sortable: true,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
    {
        field: 'endAt',
        headerName: 'Ngày kết thúc chu kì',
        editable: false,
        sortable: true,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
];
